let phoneNumber = ''
let isOtpSent = false

document.addEventListener('DOMContentLoaded', () => {
  const loginTogglerButtons = document.querySelectorAll('.login_form_toggler_button')
  const sendOtpButton = document.getElementById('sendOtp')
  const isLoginPage = document.body.classList.contains('template-customers-login')

  const emailLoginCont = document.querySelector('.email_login_cont')
  const otpLoginCont = document.querySelector('.otp_login_cont')

  const emailRegisterCont = document.querySelector('.email_register_cont')
  const otpRegisterCont = document.querySelector('.otp_register_cont')

  function toggleInputState(container, isEnabled) {
    container.querySelectorAll('input').forEach((input) => {
      input.disabled = !isEnabled
    })
  }
  

  loginTogglerButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      loginTogglerButtons.forEach((btn) => {
        btn.classList.remove('active')
      })

      if (index === 1) {
        document.querySelector('.login_form_toggler').classList.add('switched')

        if (isLoginPage) {
          emailLoginCont.style.display = 'none'
          otpLoginCont.style.display = 'flex'
          toggleInputState(emailLoginCont, false)
          toggleInputState(otpLoginCont, true)
        } else {
          emailRegisterCont.style.display = 'flex'
          otpRegisterCont.style.display = 'none'
          toggleInputState(emailRegisterCont, true)
          toggleInputState(otpRegisterCont, false)
        }
      } else {
        document.querySelector('.login_form_toggler').classList.remove('switched')

        if (isLoginPage) {
          emailLoginCont.style.display = 'flex'
          otpLoginCont.style.display = 'none'
          toggleInputState(emailLoginCont, true)
          toggleInputState(otpLoginCont, false)
        } else {
          emailRegisterCont.style.display = 'none'
          otpRegisterCont.style.display = 'grid'
          toggleInputState(emailRegisterCont, false)
          toggleInputState(otpRegisterCont, true)
        }
      }
      button.classList.add('active')
    })
  })

  const otpCont = document.querySelector('.otp_cont')
  const phoneInput = document.getElementById('CustomerPhone')
  const otpInputs = document.querySelectorAll('.otp_input')
  const statusMessageParent = document.getElementById('statusMessageParent')

  const statusMessageBox = document.createElement('div')
  statusMessageBox.classList.add('status-message')
  statusMessageParent.insertAdjacentElement('afterend', statusMessageBox)

  otpCont.style.display = 'none'

  const style = document.createElement('style')
  style.textContent = `
    #CustomerPhone.invalid {
      border-color: #f44336 !important;
      border-width: 2px !important;
    }

    #sendOtp,
    #verifyOtp {
      transition: opacity 0.3s ease;
    }

    #sendOtp:disabled,
    #verifyOtp:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .status-message {
      padding: 10px;
      border-radius: 4px;
      margin-top: 10px;
      display: none;
      text-align: center;
      width: 100%;
      font-size: 14px;
      line-height: 1.4;
    }

    .status-message.error {
      background-color: #ffebee;
      color: #c62828;
      border: 1px solid #ef9a9a;
    }

    .status-message.success {
      background-color: #e8f5e9;
      color: #2e7d32;
      border: 1px solid #a5d6a7;
    }
  `
  document.head.appendChild(style)

  // List of allowed country codes (as strings, without '+')
  const ALLOWED_PHONE_CODES = [
    '995', // GE
    '49', // DE
    '33', // FR
    '39', // IT
    '34', // ES
    '1', // US, CA
    '44', // GB
    '48', // PL
    '90', // TR
    '994', // AZ
    '374', // AM
    '7', // RU, KZ
    '380', // UA
    '375', // BY
    '998', // UZ
    '992', // TJ
    '996', // KG
    '86', // CN
    '81', // JP
    '82', // KR
  ]

  function startsWithAllowedCode(cleaned) {
    return ALLOWED_PHONE_CODES.some((code) => cleaned.startsWith(code))
  }

  function isGeorgianLocal(number) {
    return /^5\d{8}$/.test(number)
  }

  function isValidPhoneNumber(input) {
    const cleaned = input.replace(/\D/g, '')

    if (isGeorgianLocal(cleaned)) return true

    return startsWithAllowedCode(cleaned) && cleaned.length >= 8
  }

  function formatPhoneNumber(number) {
    const cleaned = number.replace(/\D/g, '')
    if (isGeorgianLocal(cleaned)) return '995' + cleaned
    return cleaned
  }

  phoneInput?.addEventListener('input', (e) => {
    let number = e.target.value
    const isValid = isValidPhoneNumber(number)

    if (!isValid) {
      phoneInput.classList.add('invalid')
    } else {
      phoneInput.classList.remove('invalid')
    }
  })

  const verifyOtpButton = document.getElementById('verifyOtp')

  function updateVerifyButtonState() {
    const allFilled = Array.from(otpInputs).every((input) => input.value.length === 1)
    verifyOtpButton.disabled = !allFilled
  }

  otpInputs.forEach((input, index) => {
    input.setAttribute('name', `otp_${index + 1}`)

    input.addEventListener('input', (e) => {
      const value = e.target.value.replace(/\D/g, '').slice(0, 1)
      e.target.value = value

      if (value) {
        const nextInput = otpInputs[index + 1]
        if (nextInput) {
          nextInput.focus()
        }
      }
      updateVerifyButtonState()
    })

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace' && !e.target.value) {
        const prevInput = otpInputs[index - 1]
        if (prevInput) {
          prevInput.focus()
          prevInput.value = ''
        }
      }

      if (e.key === 'Enter') {
        e.preventDefault()
        if (index === otpInputs.length - 1) {
          verifyOtpButton?.click()
        } else {
          const nextInput = otpInputs[index + 1]
          if (nextInput) nextInput.focus()
        }
      }
    })

    input.addEventListener('paste', (e) => {
      e.preventDefault()
      const pastedData = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, otpInputs.length)

      if (pastedData) {
        otpInputs.forEach((input, i) => {
          input.value = pastedData[i] || ''
        })

        const lastFilledIndex = Math.min(pastedData.length - 1, otpInputs.length - 1)
        if (lastFilledIndex < otpInputs.length - 1) {
          otpInputs[lastFilledIndex + 1]?.focus()
        }
      }
    })
  })

  phoneInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (!sendOtpButton.disabled) {
        sendOtpButton?.click()
      }
    }
  })

  function showStatus(message, isError = false) {
    if (!statusMessageBox) return

    statusMessageBox.textContent = message
    statusMessageBox.className = 'status-message'
    statusMessageBox.classList.add(isError ? 'error' : 'success')
    statusMessageBox.style.display = 'block'

    if (window.statusTimeout) {
      clearTimeout(window.statusTimeout)
    }

    window.statusTimeout = setTimeout(
      () => {
        statusMessageBox.style.display = 'none'
      },
      isError ? 5000 : 3000
    )
  }

  sendOtpButton?.addEventListener('click', async () => {
    phoneNumber = formatPhoneNumber(phoneInput.value)

    if (!phoneNumber.match(/^995\d{9}$/)) {
      showStatus('გთხოვთ შეიყვანოთ სწორი ტელეფონის ნომერი', true)
      phoneInput.classList.add('invalid')
      return
    }

    phoneInput.classList.remove('invalid')
    sendOtpButton.disabled = true

    try {
      const response = await fetch('https://otp-auth.meama.ge/api/auth/send-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phoneNumber }),
      })

      if (response.status === 429) {
        throw new Error('ძალიან ბევრი მოთხოვნა. გთხოვთ სცადოთ მოგვიანებით.\nToo many OTP requests, please try again later.')
      }

      const data = await response.json()

      if (data.success) {
        isOtpSent = true
        phoneInput.parentElement.style.display = 'none'
        otpCont.style.display = 'flex'
        showStatus('კოდი გამოგზავნილია', false)
      } else {
        throw new Error(data.message || 'სერვერთან დაკავშირება ვერ მოხერხდა')
      }
    } catch (error) {
      showStatus(error.message, true)
      console.error('Error:', error)
    } finally {
      sendOtpButton.disabled = false
    }
  })

  updateVerifyButtonState()

  verifyOtpButton?.addEventListener('click', async () => {
    const otp = Array.from(otpInputs)
      .map((input) => input.value)
      .join('')

    if (!otp) {
      showStatus('გთხოვთ შეიყვანოთ კოდი', true)
      return
    }

    verifyOtpButton.disabled = true
    try {
      const response = await fetch('https://otp-auth.meama.ge/api/auth/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phoneNumber,
          otp,
        }),
      })

      const data = await response.json()

      if (data.success) {
        showStatus('წარმატებით შეხვედით', false)
        if (data.redirectUrl) {
          window.location.href = data.redirectUrl
        }
      } else {
        showStatus(data.message || 'არასწორი კოდი', true)
        if (data.redirectUrl) {
          window.location.href = data.redirectUrl
        }
        if (data.remainingAttempts) {
          showStatus(`დარჩენილი მცდელობების რაოდენობა: ${data.remainingAttempts}`, true)
        }
      }
    } catch (error) {
      showStatus('სერვერთან დაკავშირება ვერ მოხერხდა', true)
      console.error('Error:', error)
    } finally {
      verifyOtpButton.disabled = false
    }
  })
})
